import { buildEnumMapProvider } from 'sc-common';
import { ReviewStatusEnum } from 'sc-common/core/services/open-api/main-api-client';

export const reviewStatusEnumMapProvider = buildEnumMapProvider(ReviewStatusEnum, getEnumText, getEnumStyles);

export function getEnumText(value: ReviewStatusEnum): string {

    switch (value) {

        case ReviewStatusEnum.Agreed:
            return $localize`Agreed`;

        case ReviewStatusEnum.Approved:
            return $localize`Approved`;

        case ReviewStatusEnum.Assigned:
            return $localize`Assigned`;

        case ReviewStatusEnum.Canceled:
            return $localize`Canceled`;

        case ReviewStatusEnum.Refused:
            return $localize`Refused`;

        case ReviewStatusEnum.Reviewed:
            return $localize`Reviewed`;
    }
}

export function getEnumStyles(status: ReviewStatusEnum): string {

    switch (status) {

        case ReviewStatusEnum.Approved:
        case ReviewStatusEnum.Reviewed:
            return 'fa-check-circle success';

        case ReviewStatusEnum.Agreed:
        case ReviewStatusEnum.Assigned:
            return 'fa-check-circle warning';

        case ReviewStatusEnum.Canceled:
        case ReviewStatusEnum.Refused:
            return 'fa-times-circle danger';

        default:
            return '';
    }
}
